import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, ShieldCheckIcon, UserCheckIcon, ZapIcon, UserCogIcon, HeadphonesIcon, MessagesSquareIcon } from 'lucide-react';
import { SectionHeading } from './shared/SectionHeading';
const features = [{
  icon: AwardIcon,
  title: 'Profesionalnost',
  desc: 'Stručan, iskusan i posvećen tim koji njegu shvata ozbiljno.'
}, {
  icon: ShieldCheckIcon,
  title: 'Sigurnost',
  desc: 'Vaša sigurnost i mir su naš najveći prioritet u svakom koraku.'
}, {
  icon: UserCheckIcon,
  title: 'Provjereni kandidati',
  desc: 'Svaki njegovatelj prolazi detaljnu provjeru i selekciju.'
}, {
  icon: ZapIcon,
  title: 'Brza organizacija',
  desc: 'Efikasno pronalazimo rješenje i organizujemo njegu u kratkom roku.'
}, {
  icon: UserCogIcon,
  title: 'Individualan pristup',
  desc: 'Svaku situaciju rješavamo prilagođeno stvarnim potrebama porodice.'
}, {
  icon: HeadphonesIcon,
  title: 'Podrška 24/7',
  desc: 'Dostupni smo u svakom trenutku, danju i noću, kad god zatreba.'
}, {
  icon: MessagesSquareIcon,
  title: 'Transparentna komunikacija',
  desc: 'Jasno, iskreno i otvoreno u svakoj fazi saradnje.'
}];
export function WhyChooseUs() {
  return <section id="zasto-mi" className="relative w-full bg-white py-20 lg:py-28" data-id="element-285">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-286">
        <SectionHeading eyebrow="Zašto mi" title="Zašto porodice biraju Golden Care" subtitle="Gradimo povjerenje kroz kvalitet, pouzdanost i istinsku brigu o svakom korisniku." data-id="element-287" />

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-288">
          {features.map((f, i) => <motion.article key={f.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.1
        }} whileHover={{
          y: -6
        }} className={`group relative overflow-hidden rounded-3xl border border-cream bg-cream/50 p-8 transition-all hover:border-gold/30 hover:bg-white hover:shadow-luxury ${i === 6 ? 'sm:col-span-2 lg:col-span-1' : ''}`} data-id="element-289">
              <span className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-gold-gradient text-white shadow-gold" data-id="element-290">
                <f.icon className="h-6 w-6" data-id="element-291" />
              </span>
              <h3 className="font-display text-xl font-bold text-ink" data-id="element-292">
                {f.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-293">
                {f.desc}
              </p>
              <span className="pointer-events-none absolute -right-6 -top-6 font-display text-7xl font-black text-gold/5 transition-colors group-hover:text-gold/10" data-id="element-294">
                {String(i + 1).padStart(2, '0')}
              </span>
            </motion.article>)}
        </div>
      </div>
    </section>;
}